<template>
    <section class="bg-[#f9f5ed] md:py-28 py-14 md-max:pb-20">
        <div class="max-w-screen-xl px-2 mx-auto lg:px-7 md:px-8 sm:px-4 font-ww-medium">
            <div
                class="mx-auto font-bold text-center leading-72 md:leading-64 text-58 sm:text-66 md:px-2 font-ww-medium text-lifeboost-gray-lighter"
                v-html="headingText"></div>

            <div class="grid grid-cols-10 -mt-8 md:mt-10 sm:grid-cols-12">
                <div class="col-span-4 sm:col-span-6"></div>
                <div class="relative flex items-end col-span-3">
                    <div class="w-full">
                        <nuxt-img :src="mainProductImgSrc" :alt="mainProductImgAlt"
                                  sizes="xs:60px sm:80px md:109px lg:100px xl:100px 2xl:100px"
                                  class="relative z-10 mx-auto md:w-24 md:bottom-1 -bottom-12 md:-mb-14 md-max:w-20"
                                  width="112" height="190" format="webp" loading="lazy"></nuxt-img>
                    </div>
                </div>

                <div class="relative flex items-end col-span-3">
                    <div class="w-full">
                        <nuxt-img :src="secondaryProductImgSrc" :alt="secondaryProductImgAlt"
                                  sizes="xs:45px sm:60px md:80px lg:70px xl:70px 2xl:74px"
                                  class="z-10 mx-auto -mb-3 md:w-16 md:mb-0 md-max:w-14"
                                  width="76" height="133" format="webp" loading="lazy"></nuxt-img>
                    </div>
                    <div class="absolute text-center md:text-lg font-normal font-ww-medium md:font-ww-regular text-xs text-[#705b43] md:-bottom-7 -bottom-8 w-full -translate-x-2/4 left-2/4" v-html="secondaryProductLabel"></div>
                </div>
            </div>

            <div class="grid grid-cols-10 sm:grid-cols-12" :class="index == 0 ? 'mt-10' : ''" v-for="(row, index) in rows" :key="index">
                <div class="col-span-4 sm:col-span-6">
                    <div :class="index == 0 ? 'fisrt-row-col-one md:!pb-10' : (index == rows.length - 1 ? 'last-row-col-one' : 'second-row-col-one')" v-html="row.title"></div>
                </div>
                <div class="col-span-3" :class="index == 0 ? '-mt-5' : (index == rows.length - 1 ? '-mb-5' : '')">
                    <div :class="index == 0 ? 'first-row-col-two md:!pb-10' : (index == rows.length - 1 ? 'last-row-col-two ' : 'second-row-col-two')" >
                        <div v-if="row.firstColumn.type === 'image'">
                            <nuxt-img :src="row.firstColumn.imgSrc" :alt="row.firstColumn.alt"
                                      :width="row.firstColumn.width" :height="row.firstColumn.height" format="webp"
                                      loading="lazy" class="md-max:w-8"></nuxt-img>
                        </div>
                        <div :class="index== 0 ? 'pt-6' :''" v-else v-html="row.firstColumn.content"></div>
                    </div>
                </div>
                <div class="col-span-3">
                    <div :class="index == 0 ? 'first-row-col-three md:!pb-10' : (index == rows.length - 1 ? 'last-row-col-three ' : 'second-row-col-three')" >
                        <div v-if="row.secondColumn.type === 'image'">
                            <nuxt-img :src="row.secondColumn.imgSrc" :alt="row.secondColumn.alt"
                                      :width="row.secondColumn.width" :height="row.secondColumn.height" format="webp"
                                      loading="lazy" class="md-max:w-8"></nuxt-img>
                        </div>
                        <div v-else v-html="row.secondColumn.content"></div>
                    </div>
                </div>
            </div>

            <div class="flex justify-center mt-20 mb-6 md:mt-24 md-max:px-3">
                <button @click="scrollTo(buttonLink,scrollPosition(mobilePosition))"
                 class="flex items-center bnt-icon md-max:w-full">
                    <span class="flex items-center" v-html="buttonText"></span>
                    <svg class="relative ml-4 top-0.5 sm:w-auto w-8" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="38px" height="31px" viewBox="0 0 38 31">
                        <path fill-rule="evenodd" fill="rgb(255, 255, 255)" d="M37.423,17.013 L24.160,30.420 C23.389,31.199 22.139,31.200 21.369,30.422 C20.599,29.643 20.600,28.381 21.371,27.601 L31.183,17.683 L1.631,17.683 C0.730,17.683 -0.001,16.945 -0.001,16.033 L-0.001,15.338 C-0.001,14.426 0.730,13.688 1.631,13.688 L31.541,13.688 L21.362,3.398 C20.592,2.619 20.593,1.357 21.364,0.577 C22.135,-0.202 23.384,-0.203 24.154,0.575 L37.401,13.965 C37.743,14.311 37.924,14.754 37.962,15.206 C38.088,15.839 37.909,16.522 37.423,17.013 Z"></path>
                    </svg>
                </button>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    headingText: {
        type: String,
        default: "Ultra Premium, Healthy Coffee Upgraded with Real Organic Mushrooms"
    },
    mainProductImgSrc: {
        type: String,
        default: "/assets/images/table-product.png"
    },
    mainProductImgAlt: {
        type: String,
        default: "product with gift"
    },
    secondaryProductImgSrc: {
        type: String,
        default: "/assets/images/table-product-2.png"
    },
    secondaryProductImgAlt: {
        type: String,
        default: "product with gift"
    },
    secondaryProductLabel: {
        type: String,
        default: "Regular Coffee"
    },
    buttonText: {
        type: String,
        default: "Try it now"
    },
    buttonLink: {
        type: String,
        default: "the-products"
    },
    mobilePosition: {
        type: String,
        default: 'bottom'
    },
    rows: {
        type: Array,
        default: () => [
            {
                title: "Coffee Quality",
                firstColumn: {
                    type: "text",
                    content: "Premium Arabica"
                },
                secondColumn: {
                    type: "text",
                    content: "Low quality"
                }
            },
            {
                title: "100% Real Mushrooms",
                firstColumn: {
                    type: "text",
                    content: "We only use fruiting body extracts, not low-quality (cheap) mycelium."
                },
                secondColumn: {
                    type: "text",
                    content: "No mushrooms, no mind-boosting benefits."
                }
            },
            {
                title: "Certified Organic",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "Low Acid",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "No Jitters",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "Tested for 400+ Toxins",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "High-Elevation Grown Coffee",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "Single Origin Coffee",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "Shade Grown Coffee",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "Hand-Picked & Hand-Washed Coffee Beans",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "Fairly Traded Coffee",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            }
        ]
    }
});

defineBuilderComponent({
    friendlyName: "Table With Checkbox",
    inputs: [
        {
            name: "headingText",
            type: "richText",
            friendlyName: "Heading Text",
            defaultValue: "Ultra Premium, Healthy Coffee Upgraded with Real Organic Mushrooms"
        },
        {
            name: "buttonText",
            type: "string",
            friendlyName: "Button Text",
            defaultValue: "Try it now"
        },
        {
            name: "buttonLink",
            type: "String",
            friendlyName: "Button Link",
            defaultValue: "the-products"
        },
        {
            name: 'mobilePosition',
            type: 'enum',
            friendlyName: 'Scroll Position mobile',
            enum: [
                { label: 'Bottom', value: 'bottom' },
                { label: 'Top', value: 'top' }
            ],
            defaultValue: 'Bottom',
        },
        {
            name: "mainProductImgSrc",
            type: "file",
            friendlyName: "Main Product Image Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/table-product.png"
        },
        {
            name: "mainProductImgAlt",
            type: "string",
            friendlyName: "Main Product Image Alt Text",
            defaultValue: "product with gift"
        },
        {
            name: "secondaryProductImgSrc",
            type: "file",
            friendlyName: "Secondary Product Image Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/table-product-2.png"
        },
        {
            name: "secondaryProductImgAlt",
            type: "string",
            friendlyName: "Secondary Product Image Alt Text",
            defaultValue: "product with gift"
        },
        {
            name: "secondaryProductLabel",
            type: "string",
            friendlyName: "Secondary Product Label",
            defaultValue: "Regular Coffee"
        },
        {
            name: "rows",
            type: "list",
            friendlyName: "Table Rows",
            subFields: [
                { name: "title", type: "richText", friendlyName: "Row Title", defaultValue: "" },
                {
                    name: "firstColumn",
                    type: "object",
                    friendlyName: "First Column",
                    subFields: [
                        { name: "type", type: "string", enum: ["text", "image"], friendlyName: "Content Type", defaultValue: "text" },
                        { name: "content", type: "richText", friendlyName: "Text Content", defaultValue: "" },
                        { name: "imgSrc", type: "file", friendlyName: "Image Source", allowedFileTypes: ["jpeg", "jpg", "png", "webp"], defaultValue: "" },
                        { name: "alt", type: "string", friendlyName: "Image Alt Text", defaultValue: "" },
                        { name: "width", type: "number", friendlyName: "Image Width", defaultValue: 47 },
                        { name: "height", type: "number", friendlyName: "Image Height", defaultValue: 47 }
                    ]
                },
                {
                    name: "secondColumn",
                    type: "object",
                    friendlyName: "Second Column",
                    subFields: [
                        { name: "type", type: "string", enum: ["text", "image"], friendlyName: "Content Type", defaultValue: "text" },
                        { name: "content", type: "richText", friendlyName: "Text Content", defaultValue: "" },
                        { name: "imgSrc", type: "file", friendlyName: "Image Source", allowedFileTypes: ["jpeg", "jpg", "png", "webp"], defaultValue: "" },
                        { name: "alt", type: "string", friendlyName: "Image Alt Text", defaultValue: "" },
                        { name: "width", type: "number", friendlyName: "Image Width", defaultValue: 47 },
                        { name: "height", type: "number", friendlyName: "Image Height", defaultValue: 47 }
                    ]
                }
            ],
            defaultValue: [
            {
                title: "Coffee Quality",
                firstColumn: {
                    type: "text",
                    content: "Premium Arabica"
                },
                secondColumn: {
                    type: "text",
                    content: "Low quality"
                }
            },
            {
                title: "100% Real Mushrooms",
                firstColumn: {
                    type: "text",
                    content: "We only use fruiting body extracts, not low-quality (cheap) mycelium."
                },
                secondColumn: {
                    type: "text",
                    content: "No mushrooms, no mind-boosting benefits."
                }
            },
            {
                title: "Certified Organic",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "Low Acid",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "No Jitters",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "Tested for 400+ Toxins",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "High-Elevation Grown Coffee",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "Single Origin Coffee",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "Shade Grown Coffee",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "Hand-Picked & Hand-Washed Coffee Beans",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            },
            {
                title: "Fairly Traded Coffee",
                firstColumn: {
                    type: "image",
                    imgSrc: "/assets/images/check-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                },
                secondColumn: {
                    type: "image",
                    imgSrc: "/assets/images/x-table.png",
                    alt: "checkbox",
                    width: 47,
                    height: 47
                }
            }
            ]
        }
    ]
});
</script>


<style lang="postcss" scoped>

.fisrt-row-col-one {
  @apply flex items-center justify-center h-full px-2 py-4 font-bold text-center border-l md:py-16 text-lg md:text-26 md:px-8 sm:px-3 rounded-tl-xl border-lifeboost-black-100 border-y font-ww-medium bg-lifeboost-green-300 text-lifeboost-brown-200
}

.first-row-col-two {
    @apply flex items-center justify-center h-full text-center md:py-16 py-4 md:text-26 text-lg text-white md:px-8 sm:px-3 px-2 border rounded-t-xl border-lifeboost-black-100 border-b-[#f1bd82] bg-lifeboost-orange-dark font-ww-regular
}

.first-row-col-three {
    @apply flex items-center justify-center h-full px-2 py-4 text-lg text-center border-r md:py-16 md:px-8 sm:px-3 md:text-26 rounded-tr-xl border-lifeboost-black-100 border-y font-ww-regular text-lifeboost-brown-200
}

.second-row-col-one {
    @apply flex items-center justify-center h-full px-2 py-3 font-bold text-center border-b border-l md:py-10 md:px-8 sm:px-3 text-lg md:text-26 border-lifeboost-black-100 font-ww-medium bg-lifeboost-green-300 text-lifeboost-brown-200
}

.second-row-col-two {
    @apply flex items-center justify-center text-center h-full sm:py-4 md-max:leading-5 py-3 md:text-2xl text-15 text-white md:px-8 sm:px-3 px-2 border border-lifeboost-black-100 border-y-[#f1bd82] bg-lifeboost-orange-dark font-ww-regular
}

.second-row-col-three {
    @apply flex items-center justify-center h-full px-2 py-3 text-15 md-max:leading-5 text-center border-b border-r sm:py-4 md:px-8 sm:px-3 md:text-2xl border-lifeboost-black-100 font-ww-regular text-lifeboost-brown-200
}

.last-row-col-one {
    @apply flex items-center justify-center md-max:pb-10 md-max:!pt-7 md:!pt-7 md:pb-16 h-full px-2 font-bold text-center border-b border-l rounded-bl-xl md:px-8 sm:px-3 md:text-26 border-lifeboost-black-100 font-ww-medium bg-lifeboost-green-300 text-lifeboost-brown-200
}

.last-row-col-two {
    @apply flex items-center justify-center lg:!pt-3 text-center h-full !leading-5 md-max:pt-0 md:py-12 py-4 rounded-b-xl md:text-26 text-lg text-white md:px-8 sm:px-3 px-2 border border-lifeboost-black-100 border-b-black border-y-[#f1bd82] bg-lifeboost-orange-dark font-ww-medium
}

.last-row-col-three {
    @apply flex items-center justify-center h-full lg:pb-10 lg:!pt-3 md-max:pt-0 px-2 py-4 text-lg text-center border-b border-r rounded-br-xl md:py-12 md:px-8 sm:px-3 md:text-26 border-lifeboost-black-100 font-ww-medium text-lifeboost-gray-lighter
}

</style>